module.exports = __webpack_public_path__ + "static/hapi-2728d72682a348933530e953fcb37d94.png";